import { REDUX_DEFAULT_DOMAIN_LIST_KEY } from 'modules/redux/constants'
import getInstancesFromDomainMapReduxUtil from 'modules/redux/utils/legacy/get-instances-from-domain-map'
import { addOrReplaceParameterLocationUtil } from 'modules/router/utils'
import {
  SECTIONS_ITEMS_COUNT_PER_PAGE,
  SECTIONS_OPTION
} from 'modules/sections/constants/index.cjs'
import { getObjectUtil } from 'packages/src'

/**
 * The list of options available.
 * @type {String[]}
 */
const QUERY_OPTIONS = [
  'exact',
  'offset',
  'category',
  'limit',
  'published',
  'featured',
  'expand', // TODO handle multiple values
  'query',
  'q',
  'name'
]

/**
 * Gets the instances in the given domain,
 * matching the category/isFeatured filter if needed.
 * @param  {Domain} domain
 * @param  {string}  [category]
 * @param  {Object} [options={}]
 *         {Object} [SECTIONS_OPTION.FEATURED]
 * @param  {boolean} [isNew]
 * @returns {Instance[]}
 */
function getInstancesSectionUtil ({
  domain,
  category,
  options = {},
  isNew
}) {
  if (isNew) {
    return []
  }
  // Get the DomainList key
  const domainListKey = category || REDUX_DEFAULT_DOMAIN_LIST_KEY
  // Get the Domain data and DomainList data
  const domainData = getObjectUtil(domain, 'data')
  const domainListData = getObjectUtil(domain, `${domainListKey}.data`)
  // Get the instances
  const instances = getInstancesFromDomainMapReduxUtil(domainData, domainListData)
  // Get the `isFeatured` option
  const isFeatured = options[SECTIONS_OPTION.FEATURED]
  // If the `isFeatured` is not provided,
  // return the instances
  if (!isFeatured) {
    return instances
  }
  // Return the featured instances
  return instances.filter(instance => instance && !!instance.data.featuredAt)
}

/**
 * Gets the route with the given parameters.
 * @param  {Object} params
 *         {string} params.category
 *         {string} params.endpoint
 *         {number} params.page
 *         {Object} params.query
 * @returns {string}
 */
function getEndpointSectionUtil (params) {
  const {
    category,
    page,
    query
  } = params
  let {
    endpoint
  } = params

  if (category) {
    endpoint = addOrReplaceParameterLocationUtil({
      name: 'category',
      value: category,
      path: endpoint
    })
  }

  Object.keys(query).forEach((name) => {
    const value = query[name]
    if (QUERY_OPTIONS.includes(name)) {
      endpoint = addOrReplaceParameterLocationUtil({
        name,
        value,
        path: endpoint
      })
    }
  })

  // TODO use items' last updated at
  if (page > 1 && !(query.query || query.q)) {
    endpoint = addOrReplaceParameterLocationUtil({
      name: 'offset',
      value: (page - 1) * SECTIONS_ITEMS_COUNT_PER_PAGE,
      path: endpoint
    })
  }

  return endpoint
}

export {
  getInstancesSectionUtil,
  getEndpointSectionUtil
}
